import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SlideIn } from "@faire/retailer-visitor-shared/components/SlideIn";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { handleKeyDown } from "@faire/retailer-visitor-shared/lib/handleKeyDown";
import { useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutHomepageRedesignV2";
import { Carousel } from "@faire/web--source/slate-labs/Carousel/Carousel";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import classNames from "classnames";
import * as React from "react";
// eslint-disable-next-line import/no-unassigned-import
import "./pillWithContentAnimation.tw.css";
export var PillWithContent = function(param) {
    var tabs = param.tabs, title = param.title, children = param.children, eventTrackingName = param.eventTrackingName, loadTimingRef = param.loadTimingRef, pauseScroll = param.pauseScroll, resumeScroll = param.resumeScroll, currentIndex = param.currentIndex, setCurrentIndex = param.setCurrentIndex, isVisible = param.isVisible;
    var isXLargeAndAbove = useViewport().isXLargeAndAbove;
    var selectedTab = tabs === null || tabs === void 0 ? void 0 : tabs[currentIndex];
    var handleClickTab = function(index, tabName) {
        if (tabName) {
            trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick("".concat(eventTrackingName, "-tab"), tabName, "".concat(homepageRedesignVariant));
        }
        pauseScroll();
        setCurrentIndex(index);
        setTimeoutIfPossible(function() {
            resumeScroll();
        }, 12000);
    };
    var homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
    var headerRef = useDoActionWhenVisible(function() {
        return trackLoggedOutRetailersLoggedOutHomeRedesignView("".concat(eventTrackingName, "-header"), "".concat(homepageRedesignVariant));
    });
    var tabRef = useDoActionWhenVisible(function() {
        return trackLoggedOutRetailersLoggedOutHomeRedesignView("".concat(eventTrackingName, "-tab"), "".concat(homepageRedesignVariant));
    });
    return /*#__PURE__*/ _jsx(Column, {
        className: "mb-0 ml-4 mt-12 md:ml-8 lg:ml-12 2xl:ml-20",
        ref: loadTimingRef,
        children: /*#__PURE__*/ _jsxs(SlideIn, {
            bottomThreshold: 100,
            offset: getSpacing("5x"),
            children: [
                /*#__PURE__*/ _jsxs(Column, {
                    className: "items-start",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: {
                                mobileAndAbove: "pageHeaderSerifRegular",
                                xLargeAndAbove: "displaySSerifRegular",
                                xxLargeDesktop: "displayMSerifRegular"
                            },
                            ref: headerRef,
                            children: title
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: {
                                mobileAndAbove: "3x",
                                tabletAndAbove: "2x",
                                desktopAndAbove: "3x"
                            }
                        }),
                        /*#__PURE__*/ _jsxs(Row, {
                            justify: "space-between",
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "overflow-auto",
                                    ref: tabRef,
                                    children: /*#__PURE__*/ _jsx(Carousel, {
                                        items: tabs !== null && tabs !== void 0 ? tabs : [],
                                        renderItem: function(tab, index) {
                                            return /*#__PURE__*/ _jsx("div", {
                                                onClick: function() {
                                                    return handleClickTab(index, tab.pathIdentifier);
                                                },
                                                onKeyDown: handleKeyDown(function() {
                                                    return handleClickTab(index, tab.pathIdentifier);
                                                }),
                                                children: /*#__PURE__*/ _jsx(Typography, {
                                                    tabIndex: 0,
                                                    className: classNames("hover:border-core-border-default focus-visible:border-core-border-default flex h-10 cursor-pointer items-center justify-center rounded-[40px] border !p-4", index === currentIndex ? "border-core-border-default bg-core-surface-default text-core-text-inverse" : "border-core-border-muted"),
                                                    children: tab.tabName
                                                })
                                            }, index);
                                        },
                                        freeFlow: true,
                                        showNavigationArrows: false,
                                        itemGap: 8,
                                        loop: false,
                                        className: "w-full !pl-0",
                                        onVisible: function() {
                                            trackLoggedOutRetailersLoggedOutHomeRedesignView("".concat(eventTrackingName, "-pill-onscroll"), "".concat(homepageRedesignVariant));
                                        }
                                    })
                                }),
                                isXLargeAndAbove ? /*#__PURE__*/ _jsx(Button, {
                                    className: "xl:!pr-12 2xl:!pr-20",
                                    variant: "tertiary",
                                    linkTo: selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.ctaLink,
                                    onClick: function() {
                                        var _selectedTab_ctaLink;
                                        trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick("category_best_brands_banner_v2-cta", (_selectedTab_ctaLink = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.ctaLink) !== null && _selectedTab_ctaLink !== void 0 ? _selectedTab_ctaLink : "", "".concat(homepageRedesignVariant));
                                    },
                                    children: selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.ctaLinkText
                                }) : null
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: classNames("relative w-full overflow-hidden pr-4 md:pr-8 lg:pr-12 2xl:pr-20", isVisible ? "pill-with-content-fade-in bottom-0 opacity-100" : "pill-with-content-fade-out bottom-10 opacity-0"),
                    children: children
                })
            ]
        })
    });
};
